module.exports = __webpack_public_path__ + "static/media/SCBmovement.4ea39497.svg";